import React from "react";
import { Icon } from "./Icon";

interface Twitter32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Twitter32: React.FC<Twitter32Props> = ({
  size,
  className,
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M593.181 445.238l317.674-369.27h-75.277l-275.837 320.63-220.307-320.63h-254.1l333.15 484.851-333.15 387.235h75.282l291.289-338.598 232.662 338.598h254.099l-345.485-502.816zM490.074 565.091l-302.333-432.451h115.629l532.243 761.318h-115.629l-229.91-328.867z" />
    </Icon>
  );
};
